<template>
  <QSelect
    v-model="tierFilters"
    borderless
    class="full-width"
    clearable
    dense
    :for="`tier-select-${uid}`"
    :label="$t('tier_filters.select_tiers')"
    multiple
    :options="tierOptions"
    stack-label
    use-chips
  >
    <template #selected-item="scope">
      <QChip
        class="q-mt-sm bg-online text-white"
        dense
        removable
        square
        text-color="primary"
        @remove="scope.removeAtIndex(scope.index)"
      >
        {{ scope.opt.label }}
      </QChip>
    </template>
  </QSelect>
</template>

<script>
import { useId } from "vue";

export default {
  name: "TierFilters",
  props: {
    modelValue: {
      type: Array,
      default: null,
    },
    stream: {
      type: Object,
      required: true,
    },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      uid: useId(),
    };
  },
  computed: {
    tierFilters: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      },
    },
    tierOptions() {
      const options = [];

      for (let tier = 1; tier <= 5; tier += 1) {
        options.push({
          label: `Tier ${tier}`,
          value: tier,
        });
      }

      return options;
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.q-field__native) {
  width: 100% !important;
}

.medium-group {
  font-size: 1em;
  font-weight: bold;
  display: block;
  background-color: #f5f5f5;
  padding: 5px 5px 5px 10px;
}

.item-label {
  padding-left: 5px;
}
</style>
